"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48v2) { return function (raw) {
    var code = utils_1.hexToDec(raw.slice(8, -2));
    if (code !== 1200000) {
        console.error("Error: " + code);
    }
}; });



// WEBPACK FOOTER //
// ./src/transparent48v2/decode/10.ts